<template>
  <transition
  name="trans-bounce" 
  mode="out-in"
  enter-active-class="animated bounceInLeft faster" 
  leave-active-class="animated bounceOutRight faster"
  >

    <slot></slot>

  </transition>
</template>

<script>

export default {
  name: 'trans_bounce',
  props: [
    
  ],
  data () {
    return {
      
    }
  },
  methods: {
    
  },
  components: {
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/transitions/trans_bounce_inL_outR.vue